<template>
    <template v-if="!!goalPlan && !!patient && !!visibility">
        <goal-plan v-model="goalPlan"
                   :patient="patient"
                   :edit-state="editState"
                   :review-statuses="reviewStatuses"
                   :visibility="visibility"
                   :url-head="urlHead"
                   :flat="flat"
                   :just-relapse-prevention-plan="justRelapsePreventionPlan" />
    </template>
</template>


<script setup>
    import { defineProps, defineExpose, ref, nextTick } from 'vue';
    import axios from 'axios';
    import { axiosError, axiosConfig } from '../../js/AjaxUtilities.js';

    import GoalPlan from './GoalPlan.vue';

    const props = defineProps({
        goalPlanId: {
            type: Number,
            default: 0
        },
        editState: { // who is editing? 0 = no one (read only), 1 = clinician, 2 = patient
            type: Number,
            default: 0
        },
        urlHead: { // the start of the URL. This gets passed through
            type: String,
            default: null
        },
        flat: {
            type: Boolean,
            default: false
        },
        justRelapsePreventionPlan: {
            type: Boolean,
            default: false
        }

    });

    defineExpose({ load });

    const goalPlan = ref(null);
    const patient = ref(null);
    const reviewStatuses = ref([]);
    const visibility = ref(null);


    function load() {
        nextTick(() => loadData()); // we'll let the data flow through first
    }

    function loadData() {
        let goalPlanId = props.goalPlanId;
        axios
            .post(`/${props.urlHead}/LoadGoalPlanObjects`, goalPlanId, axiosConfig())
            .then(function (response) {
                if (response.data.success) {
                    goalPlan.value = response.data.goalPlan;
                    patient.value = response.data.patient;
                    reviewStatuses.value = response.data.reviewStatuses;
                    visibility.value = response.data.visibility;
                } else {
                    alert(`Failed to load Goal Plan: ${response.data.message}`);
                }
            })
            .catch(function (error) {
                axiosError("Load goal plan", axios, error);
            });
    }

</script>
